import styled from 'styled-components' 

import Lottie from 'react-lottie';

export const CommomContainer = styled.div.attrs({ 
})`          
    position: relative;
    padding: 0px 0 0;

    background: var(--primary-color);
`; 

export const CommomTitle = styled.div.attrs({  
})`          
    font-size: 30px;
    font-weight: bold;
    //text-align: center;
    line-height: 1em;
    color: var(--white-color);
    margin: 0;
    
    width: 100%;
    max-width: 360px;

    @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;  
 

export const CommomText = styled.div.attrs({  
})`          
    font-size: 18px;
    line-height: 1em;
    color: var(--white-color);
    margin: 15px 0 0 0;

    width: 100%;
    max-width: 360px;
`;  
 


export const CommomImageBanner = styled.img.attrs({  
    src:'/images/p3_pravoce.png'
})`           
    width: 100%;
    max-width: 540px;

    @media(max-width: 767px){
        margin-top: 20px;
        margin-botton: 20px;
    }
`;  
 
export const CommomCentred = styled.div.attrs({ 
})`          
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    
    ${
        props => props.spaced ? `
            padding-top: 20px;
        ` : ``
    }
`; 

export const BannerCenterActions = styled.div.attrs({ 
})`            
    margin: 0px auto 0px;
    flex:1;
    width: 210px;
`; 

export const BannerTitle = styled.h1.attrs({ 
})`       
    font-size: 18px;
    color: var(--darkprimary-color);    

    text-align: center;

`;

export const ColorLink = styled.div.attrs({ 
})`           
    color: var(--secondary-color);
    text-decoration: underline;  
`;